import { Pipe, type PipeTransform } from "@angular/core";
import { CountDownOptions } from "@components/mso/slider/codere-countdown-banner-template/codere-countdown-banner-template.component";

@Pipe({
  name: "codereCountDownFormat",
  standalone: true,
})
export class CountDownFormatPipe implements PipeTransform {
  transform(value: string = ""): CountDownOptions {
    const formatKeys = value.toLowerCase().split(":");
    const countDownOptions: CountDownOptions = {
      d: false,
      h: false,
      m: false,
      s: false,
    };

    Object.keys(countDownOptions).forEach((key) => {
      if (formatKeys.includes(key.toLowerCase())) {
        countDownOptions[key] = true;
      }
    });

    return countDownOptions;
  }
}
